export const getHex = value => {
    const strVal = String(value)
    const hex = strVal[0] === '#' ? strVal : `#${strVal}`
    if (hex.match(/^#([0-9a-f]{3}){1,2}$/i)) return hex.toLowerCase()
    else return null
}
